export default {
  columnOptions: "Spaltenoptionen",
  rowsPerPage: "Zeilen pro Seite",
  search: "Suche",
  // @FIXME - global should either have asset in name or be concatinated separately from entity name
  addButton: "Asset hinzufügen",
  blockUser: "Benutzer sperren",
  unblockUser: "Benutzer entsperren",
  tags: "Tags",
  filter: "Filter",
  density: "Density",
  addModelButton: "Model hinzufügen",
  edit: "bearbeiten",
  delete: "löschen",
  serialNo: "Seriennummer",
  addApp: "App hinzufügen",
  removeApp: "App entfernen",
  noData: "Keine Daten vorhanden",
  noResultsMessage: "Es sieht so aus, als hätten Ihre aktuellen Filter keine Ergebnisse zurückgegeben.",
  noDataAvailable: "Keine Daten verfügbar",
  helperMessagesNoData: {
    reviewFilters: "Überprüfen oder löschen Sie einige Filter",
    broadenCriteria: "Erweitern Sie Ihre Kriterien",
    checkCombinations: "Überprüfen Sie, ob Sie Filter in einer Weise kombinieren, die zu restriktiv ist",
    chckSpelling: "Überprüfen Sie auf Rechtschreibfehler oder Tippfehler in Ihrem Suchbegriff",
    differentAttribute: "Versuchen Sie, nach einem anderen Attribut zu suchen",
  },
  resetFilters: "Alle Filter zurücksetzen",
  sort: "Sortieren",
};
